module.exports = __webpack_public_path__ + "media/images/report_problem-24px-a24b24fd6b234200d1abcb34446a091a.svg";